import React from "react";
import { Link, useLocation } from "react-router-dom";
import { i18n } from "../../translate/i18n";
import { MASTER_HOME } from "../../helpers/masterUser";
import { MASTER_NAV_SECTIONS } from "./MasterNavItems";
import BrandLogo from "../BrandLogo";

function NavIcon({ name }) {
	const cls = "block h-full w-full";
	if (name === "system") {
		return (
			<svg className={cls} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
				<rect x="2" y="2" width="20" height="8" rx="2" />
				<rect x="2" y="14" width="20" height="8" rx="2" />
			</svg>
		);
	}
	if (name === "users") {
		return (
			<svg className={cls} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
				<path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
				<circle cx="9" cy="7" r="4" />
				<path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" />
			</svg>
		);
	}
	if (name === "companies") {
		return (
			<svg className={cls} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
				<path d="M3 21h18M5 21V7l8-4v18M19 21V11l-6-3" />
			</svg>
		);
	}
	if (name === "plans") {
		return (
			<svg className={cls} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
				<path d="M12 2v20M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6" />
			</svg>
		);
	}
	if (name === "addons") {
		return (
			<svg className={cls} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
				<path d="M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 003 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z" />
				<polyline points="3.27 6.96 12 12.01 20.73 6.96" />
				<line x1="12" y1="22.08" x2="12" y2="12" />
			</svg>
		);
	}
	if (name === "coupons") {
		return (
			<svg className={cls} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
				<path d="M20.59 13.41l-7.17 7.17a2 2 0 01-2.83 0L2 12V2h10l8.59 8.59a2 2 0 010 2.82z" />
				<line x1="7" y1="7" x2="7.01" y2="7" />
			</svg>
		);
	}
	if (name === "finance") {
		return (
			<svg className={cls} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
				<path d="M3 3v18h18" />
				<path d="M7 16l4-4 4 3 5-7" />
			</svg>
		);
	}
	if (name === "logs") {
		return (
			<svg className={cls} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
				<path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" />
				<polyline points="14 2 14 8 20 8" />
				<line x1="16" y1="13" x2="8" y2="13" />
				<line x1="16" y1="17" x2="8" y2="17" />
			</svg>
		);
	}
	if (name === "docs") {
		return (
			<svg className={cls} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
				<path d="M4 19.5A2.5 2.5 0 016.5 17H20" />
				<path d="M6.5 2H20v20H6.5A2.5 2.5 0 014 19.5v-15A2.5 2.5 0 016.5 2z" />
			</svg>
		);
	}
	return (
		<svg className={cls} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
			<rect x="3" y="3" width="7" height="7" rx="1" />
			<rect x="14" y="3" width="7" height="7" rx="1" />
			<rect x="3" y="14" width="7" height="7" rx="1" />
			<rect x="14" y="14" width="7" height="7" rx="1" />
		</svg>
	);
}

export default function MasterSidebar() {
	const location = useLocation();
	return (
		<aside
			id="app-menu"
			className="app-menu flex h-screen w-[260px] min-w-[260px] max-w-[260px] shrink-0 flex-col border-e z-40 transition-[margin,opacity] duration-300"
		>
			<BrandLogo to={MASTER_HOME} />

			<div className="relative min-h-0 flex-grow overflow-y-auto">
				<ul className="side-nav p-3" aria-label={i18n.t("master.layout.title")}>
					{MASTER_NAV_SECTIONS.map((section) => (
						<React.Fragment key={section.titleKey}>
							<li className="menu-title">{i18n.t(section.titleKey)}</li>
							{section.items.map((item) => {
								const active = item.match(location.pathname);
								return (
									<li key={item.to} className={`menu-item${active ? " active" : ""}`}>
										<Link
											to={item.to}
											title={i18n.t(item.labelKey)}
											className={`menu-link${active ? " active" : ""}`}
										>
											<span className="menu-icon">
												<NavIcon name={item.icon} />
											</span>
											<span className="menu-text">{i18n.t(item.labelKey)}</span>
										</Link>
									</li>
								);
							})}
						</React.Fragment>
					))}
				</ul>
			</div>
		</aside>
	);
}
